import { connectedAccountsStore } from '../../store/store';
import { mutatorAction } from 'satcheljs';
import strings from 'owa-strings/owa-options-strings';
export var resetConnectedFullStore = mutatorAction('resetConnectedFullStore', function (accountsInfo) {
    var store = connectedAccountsStore();
    store.accounts = [];
    store.selected = -1;
    store.accountsInfo = accountsInfo;
    if (accountsInfo) {
        for (var _i = 0, _a = accountsInfo.SyncRequests; _i < _a.length; _i++) {
            var request = _a[_i];
            var lastUpdate = request.LastUpdateTimestamp;
            if (request.Status === 'Failed' || request.Status === 'Suspended') {
                lastUpdate = strings.options_connected_full_failedStatus;
            }
            store.accounts.push({
                accountName: request.EmailAddress,
                status: request.Status,
                lastUpdate: lastUpdate,
                syncRequest: request,
            });
        }
    }
});
//# sourceMappingURL=resetConnectedFullStore.js.map